import React, { useState } from "react";
import LottiePlayer from "lottie-react";
import NoDataFoundAnim from "../../assets/animations/NoDataFound.json";

import { BootsIcon, GlovesIcon, HelmetIcon, VestIcon } from "../../assets/Icons";
import { toTitleCase } from "../../utils/common";
import moment from "moment";

const iconMapping = {
  boots: <BootsIcon />,
  gloves: <GlovesIcon />,
  helmet: <HelmetIcon />,
  vest: <VestIcon />,
}

const Persons = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? images?.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === images?.length - 1 ? 0 : prevIndex + 1));
  };

  console.log(images, "line 18")

  return (
    <>
      {images?.length > 0 ? (
        <>
          <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
            <span className="shadow-grad"></span>
            <span className="shadow-grad bottom"></span>

            <div className="carousel-indicators">
              {images?.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  data-bs-target="#carouselExampleSlidesOnly"
                  data-bs-slide-to={index}
                  className={index === currentIndex ? "active" : ""}
                  aria-current={index === currentIndex ? "true" : "false"}
                  data-bs-interval="3000"
                  aria-label={`Slide ${index + 1}`}
                  onClick={() => setCurrentIndex(index)}
                ></button>
              ))}
            </div>

            <div className="carousel-inner">
              {images?.map((item, index) => (
                <div className={`carousel-item ${index === currentIndex ? "active" : ""}`} key={item?.uuid}>
                  <img src={item.url} className="d-block slider-img" alt={`Slide ${index + 1}`} />
                  <span className="violation-time">{moment(item?.createdAt).format('LLL')}</span>
                  {/* <span className="violation-data">

                    {item?.violation?.map(value => <span>
                      {iconMapping[value]}
                      {toTitleCase(value)}
                    </span>)}
                  </span> */}
                </div>
              ))}
            </div>

            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="prev"
              onClick={handlePrev}
            >
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>

            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="next"
              onClick={handleNext}
            >
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="no-item-here">
            <LottiePlayer animationData={NoDataFoundAnim} style={{ height: 130, marginBottom: 0 }} />
            <p>No violation snapshots found</p>
          </div>
        </>
      )}
    </>
  );
};

export default Persons;
